<template>
  <div class="p-2">
    <div class="text-xs font-medium text-color-secondary mb-2 uppercase">
      Paradas — {{ sentido === 'ida' ? 'Ida' : 'Vuelta' }}
    </div>

    <div class="text-xs text-color-secondary mb-2">
      Activá el modo Paradas y hacé clic en el mapa para agregar
    </div>

    <div class="flex flex-column gap-1">
      <div
        v-for="(parada, idx) in paradas"
        :key="parada.id || idx"
        class="flex align-items-center gap-1"
      >
        <span
          class="text-xs text-color-secondary flex-shrink-0"
          style="width:18px;text-align:right"
        >{{ idx + 1 }}.</span>
        <InputText
          v-model="parada.nombre"
          :placeholder="`Parada ${idx + 1}`"
          class="flex-1 text-sm"
          size="small"
        />
        <Button
          icon="pi pi-trash"
          text
          size="small"
          severity="danger"
          @click="$emit('eliminar', idx)"
        />
      </div>

      <div v-if="paradas.length === 0" class="text-xs text-color-secondary text-center py-2">
        Sin paradas
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  linea: Object,
  sentido: { type: String, default: 'ida' },
})

defineEmits(['eliminar'])

const paradas = computed(() => props.linea?.[props.sentido]?.paradas || [])
</script>
